
<template>
    <el-dialog title="邀请师傅" :visible.sync="dialogInvite"  width="30%">
        <div class="container" style="text-align: center;">
            <img src="/img/invitation-worker.png" style="width:300px;"/>
            <p style="text-align: center;">您可以扫码进入小程序后邀请师傅将需求发送给指定的师傅</p>
        </div>
    </el-dialog>
</template>
<script>
    export default {
        data() {
            return {
                dialogInvite : false
            }
        },
        mounted() {},
        methods: {
           setsataus(){
                this.dialogInvite = true;
            },
        }
    }
</script>